import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { EntityContainer, IDButton } from "./LinkedEntities.styled";
import { loadSingleContact } from "../../../../Contact/ContactList/ContactList.actionCreators";
import { setSingleContactLoadingState } from "../../../../Contact/ContactList/ContactList.slice";
import { CONTACT_LIST_ENDPOINT } from "@utils/constants";
import AddEditContact from "../../../../Contact/AddEditContact/AddEditContact";

const LinkedEntities = (props) => {
  const { t, data } = props;
  const [isViewConatct, setIsViewConatct] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [finalLinks, setFinalLinks] = useState("");
  const dataURL = CONTACT_LIST_ENDPOINT;
  const dispatch = useDispatch();
  const history = useNavigate();
  const fetchRecords = (contactId) => {
    // Set the loading state
    dispatch(setSingleContactLoadingState());
    dispatch(
      loadSingleContact({
        dataURL,
        contactId,
      })
    );
  };

  const viewContact = (e) => {
    let contactId = e.target.dataset.key;
    let type = e.target.dataset.type;
    if (type === "contact" && contactId !== undefined) {
      setIsLoading(true);
      fetchRecords(contactId);
      setIsViewConatct(true);
    }
    if (type === "company") {
      handleNavItemClick(e);
    }
  };

  const toogleViewPopUp = () => {
    setIsViewConatct(false);
  };

  useEffect(() => {
    let links = [];
    if (data !== null && data !== undefined) {
      links.push(data.sites.reduce((p, c) => [...p, c.link], []).join(", "));
      links.push(
        data.companies.reduce((p, c) => [...p, c.link], []).join(", ")
      );
      links.push(
        data.contacts
          .reduce(
            (p, c) => [
              ...p,
              `<span data-type="contact" data-key=${c.id} >${c.name}</span>`,
            ],
            []
          )
          .join(", ")
      );
    }
    let linksData = links.filter((link) => link !== "");
    linksData = linksData.reduce((p, c) => [...p, c], []).join(", ");
    setFinalLinks(linksData);
  }, []);

  const handleNavItemClick = (e) => {
    history(e.target.dataset.link);
  };

  return (
    <>
      <EntityContainer>
        <IDButton>
          <div
            onClick={(e) => viewContact(e)}
            dangerouslySetInnerHTML={{
              __html: finalLinks,
            }}
          ></div>
        </IDButton>
      </EntityContainer>
      {isViewConatct && (
        <AddEditContact
          title={t("Contact")}
          onClose={toogleViewPopUp}
          page="viewContact"
          isEditMode={false}
          isViewMode={false}
        />
      )}
    </>
  );
};

LinkedEntities.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(LinkedEntities);
